// Dependencies
// -----------------------------------------------
import React from 'react';
import { CalendarDay } from 'react-dates';

// Components
// -----------------------------------------------
import DefaultRangePicker from './default-range-picker';
import { WidgetCalendarDay } from './widget-date-picker-styles';

// Custom Calendar Day
// -----------------------------------------------
const CustomCalendarDay = (props, calendarDayStatus) => {
  if (!props || !props.day) return <CalendarDay {...props} />;

  const modifiers = props.modifiers;

  let status = calendarDayStatus(props.day);

  if (modifiers && modifiers.has('selected-start') && status === 'check_out') {
    status = 'check_in_with_previous_check_out';
  } else if (
    modifiers &&
    modifiers.has('selected-end') &&
    status === 'check_in'
  ) {
    status = 'check_out_with_previous_check_in';
  }

  return (
    <WidgetCalendarDay status={status}>
      <CalendarDay {...props} />
    </WidgetCalendarDay>
  );
};

// Widget Date Picker Container
// -----------------------------------------------
const WidgetDatePickerContainer = (props) => {
  const calendarDayStatus = props.calendarDayStatus;
  return (
    <DefaultRangePicker
      label={props.label}
      onDatesSet={props.onDatesChange}
      onFocusChange={props.onFocusChange}
      isDayBlocked={props.isDayBlocked}
      initialStartDate={props.startDate}
      initialEndDate={props.endDate}
      isOutsideRange={props.isOutsideRange}
      renderCalendarDay={props => CustomCalendarDay(props, calendarDayStatus)}
      disabled={props.disabled}
      displayFormat={props.displayFormat}
      readOnly={props.readOnly}
      useDesignKit={props.useDesignKit}
    />
  );
};

// Export
// -----------------------------------------------
export default WidgetDatePickerContainer;
